import React, { useEffect, useState } from 'react';
import { useTranslation } from '@shared/core';
import { pxToRem } from '@withjoy/joykit/theme';
import { useMediaQuery } from '@withjoy/joykit/utils';
import { Box, StyleSystemProps } from '@withjoy/joykit';
import { animationTransitionExt } from '@shared/utils/animationTransition';

const styles = (show: boolean): StyleSystemProps => ({
  opacity: show ? 1 : 0,
  position: 'absolute',
  transition: animationTransitionExt({ property: 'opacity', duration: '500ms', timingFunction: 'ease-in', delay: show ? '500ms' : '0ms' })
});

export const AddFromFriendsWordFading: React.FC = () => {
  const [currentWordIndex, setCurrentWordIndex] = useState<number>(0);
  const { t2 } = useTranslation('addFromFriendsRegistry');
  const translations = t2('banner');

  const isMobile = useMediaQuery(theme => theme.mediaQueries.between(0, { breakpointAlias: 'md' }));
  const height = isMobile ? pxToRem(39) : pxToRem(59);

  const words = [translations.titleAnyones, translations.titleFriends, translations.titleFamily, translations.titleCelebrities];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentWordIndex(prevIndex => (prevIndex + 1) % words.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [words.length]);

  return (
    <Box position="relative" height={height}>
      {words.map((word, idx) => (
        <Box as="span" key={`slider-${word}-${idx}`} __css={styles(idx === currentWordIndex)}>
          {word}
        </Box>
      ))}
    </Box>
  );
};
